export const container = 'px-6';
export const iconContainer = 'mt-6';
export const heading = 'font-bold';
export const subHeading = 'text-xs';
export const inputContainer = 'my-3';
export const inputLabel = 'text-sm font-semibold';
export const inputBold = 'font-bold';
export const button = 'bg-custom-button-green';
